var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    {
      staticClass: "wrap-option",
      class: { selected: _vm.selectedCategory },
      attrs: { "vs-w": "12" }
    },
    [
      _c("vs-col", { attrs: { "vs-lg": "8", "vs-sm": "4", "vs-xs": "12" } }, [
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.valor,
                expression: "option.valor"
              }
            ],
            staticClass: "input-option",
            class: {
              "input-blocked": !_vm.editMood
            },
            attrs: { maxlength: "10", size: "small" },
            domProps: { value: _vm.option.valor },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.option, "valor", $event.target.value)
              }
            }
          })
        ]),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.option.descripcion,
                expression: "option.descripcion"
              }
            ],
            staticClass: "input-option",
            class: {
              "input-blocked": !_vm.editMood
            },
            attrs: { maxlength: "100", size: "small" },
            domProps: { value: _vm.option.descripcion },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.option, "descripcion", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c(
        "vs-col",
        {
          attrs: {
            "vs-type": "flex",
            "vs-justify": "flex-end",
            "vs-align": "center",
            "vs-lg": "4",
            "vs-sm": "4",
            "vs-xs": "12"
          }
        },
        [
          _vm.type === "category"
            ? _c("vs-button", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Ver documentos",
                    expression: "'Ver documentos'"
                  }
                ],
                staticClass: "margin-right",
                attrs: {
                  color: "primary",
                  size: "small",
                  type: "border",
                  icon: "search"
                },
                on: {
                  click: function($event) {
                    return _vm.listDocuments(_vm.option)
                  }
                }
              })
            : _vm._e(),
          !_vm.editMood
            ? _c(
                "CheckPermission",
                { attrs: { permission: "ED029" } },
                [
                  _c("vs-button", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Editar Opción",
                        expression: "'Editar Opción'"
                      }
                    ],
                    staticClass: "margin-right",
                    attrs: {
                      color: "primary",
                      size: "small",
                      type: "border",
                      icon: "edit"
                    },
                    on: {
                      click: function($event) {
                        return _vm.editOption()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.editMood && _vm.canProcess
            ? _c("vs-button", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: "Numeración de la opción",
                    expression: "'Numeración de la opción'"
                  }
                ],
                staticClass: "margin-right",
                attrs: {
                  disabled: "",
                  color: "primary",
                  size: "small",
                  type: "border",
                  icon: "settings_remote"
                }
              })
            : _vm._e(),
          _c(
            "CheckPermission",
            { attrs: { permission: "ED030" } },
            [
              _c("vs-switch", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.selected
                      ? "Deshabilitar opción"
                      : "Habilitar opción",
                    expression:
                      "selected ? 'Deshabilitar opción' : 'Habilitar opción'"
                  }
                ],
                attrs: { color: "primary" },
                on: {
                  click: function($event) {
                    return _vm.toggleEnableOption({
                      option: _vm.option,
                      selected: _vm.selected,
                      type: _vm.type
                    })
                  }
                },
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modalOption",
          attrs: {
            title: "Editar opción " + _vm.option.descripcion,
            "hide-footer": "",
            size: "lg",
            centered: ""
          },
          on: { close: _vm.clearNumeration }
        },
        [
          _c("ManageOption", {
            attrs: { option: _vm.option, type: _vm.type },
            on: { "save-option": _vm.saveOption }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }